import dayjs from 'dayjs';

export function useBookingData(bookings) {
  const actions = {
    getHolderData: booking => {
      const { holder, entrance, code, departure } = bookings[0];
      const roomFriendlyName = booking?.roomTypes?.[0]?.identifiers?.friendlyName || '';
      const roomType = booking?.roomTypes?.[0]?.type?.typeName || '';
      const checkInDate =
        entrance && entrance !== '-' ? dayjs(entrance).format('DD/MM/YYYY') : null;
      const checkOutDate =
        departure && departure !== '-' ? dayjs(departure).format('DD/MM/YYYY') : null;

      return {
        bookingNumber: code,
        holderName: holder,
        checkInDate,
        checkOutDate,
        roomFriendlyName,
        roomType,
      };
    },

    getSummaryData: () => {
      const bookingNumber = bookings[0]?.bookingData?.code;
      const holder = bookings[0]?.holderData;
      const holderName = [holder?.firstName, holder?.middleName, holder?.fullLastName]
        .filter(Boolean)
        .join(' ');
      const checkInDate = bookings[0]?.bookingData?.entranceDate;
      const checkOutDate = bookings[0]?.bookingData?.departureDate;
      return {
        bookingNumber,
        holderName,
        checkInDate,
        checkOutDate,
      };
    },
  };

  return { actions };
}
